const newApi = require('payrailz-ontrac-sdk-core/src/api');
const {
  createConfig,
} = require('payrailz-ontrac-sdk-core/src/Payrailz/common');
const addTopLevelFunctions = require('payrailz-ontrac-sdk-core/src/fluid-interface/resources/TopLevel');
const BrowserAccessTokenProvider = require('../api/accessTokenProvider/BrowserAccessTokenProvider');
const NoAccessTokenProvider = require('../api/accessTokenProvider/NoAccessTokenProvider');

function addResources(client, resources) {
  Object.keys(resources).forEach((resourceKey) => {
    client[resourceKey] = resources[resourceKey]({ client });
  });

  addTopLevelFunctions(client);
}

function BrowserClient({
  resources,
  authHost,
  extraRequestHttpOptions,
  httpClient,
  noAccessToken,
  config = {},
}) {
  if (!(this instanceof BrowserClient)) {
    return new BrowserClient({
      resources,
      authHost,
      extraRequestHttpOptions,
      httpClient,
      noAccessToken,
      config,
    });
  }

  const AccessTokenProvider = noAccessToken
    ? NoAccessTokenProvider
    : BrowserAccessTokenProvider;
  const accessTokenProvider = new AccessTokenProvider(
    authHost,
    extraRequestHttpOptions
  );
  const api = newApi(accessTokenProvider, httpClient);
  const clientConfig = createConfig(config);

  Object.defineProperty(this, '_setKey', {
    value(key, value) {
      clientConfig[key] = value;
    },
    writable: true,
    configurable: true,
  });

  this.getKey = function getKey(key) {
    return clientConfig[key];
  };

  this.executeRequest = async function executeRequest(...args) {
    return api.executeRequest(...args);
  };

  this.executeIFPPalRequest = async function executeIFPPalRequest(...args) {
    return api.executeIFPPalRequest(...args);
  };

  this.extendEndpoints = function extendEndpoints(extraEndpoints) {
    return api.extendEndpoints(extraEndpoints);
  };

  this.clearCache = () => {
    accessTokenProvider.clearCache();
  };

  this.getEnvironment = () => {
    return accessTokenProvider.environment;
  };

  this.addMetrics = async function addMetrics(data, cb) {
    return api.executeRequest('POST', '/metrics', {
      httpOptions: {
        host: authHost,
      },
      data,
      cb,
    });
  };

  this.setExtraRequestHttpOptions = (httpOptions) => {
    accessTokenProvider.extraRequestHttpOptions = httpOptions;
  };

  api.configure(clientConfig);
  addResources(this, resources);
}

module.exports = (resources) => (options) => {
  return new BrowserClient({ resources, ...options });
};
